<div app-landing-page-section-container>
    <div class="flex flex-col md:flex-row items-center">
        <div
            [ngClass]="[
                'mat-headline-5 our-mission text-primary',
                'text-left w-full pl-0 pb-4 ',
                'md:text-center md:w-min md:pl-5 md:pb-0',
                'lg:pl-[60px]',
            ]"
        >
            {{ 'LandingPageMissionHeading1' | translate }}
            <br class="hidden md:block" />
            {{ 'LandingPageMissionHeading2' | translate }}
        </div>

        <div
            [ngClass]="[
                'self-stretch border-4 border-primary border-solid border-r',
                'hidden',
                'md:block md:mx-10',
            ]"
        ></div>

        <div class="grow">
            <p class="m-0 pr-0 md:pr-10 text-lg" translate>
                LandingPageMissionText
            </p>
        </div>
    </div>
</div>
